import React from "react";

const AttachIcon = ({ className = "", restProps }) => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...restProps}
    >
      <path
        d="M13.5046 11.8313L10.1712 8.49796L6.83789 11.8313"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1711 8.49796V15.998"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1628 13.823C17.9756 13.3798 18.6176 12.6787 18.9877 11.8301C19.3577 10.9816 19.4346 10.034 19.2063 9.13686C18.9779 8.23974 18.4573 7.44421 17.7267 6.87582C16.996 6.30744 16.0968 5.99856 15.1711 5.99795H14.1211C13.8689 5.02232 13.3987 4.11656 12.7461 3.34878C12.0934 2.58099 11.2751 1.97116 10.3529 1.56512C9.43057 1.15909 8.42823 0.967418 7.42121 1.00452C6.41418 1.04162 5.42867 1.30654 4.53876 1.77934C3.64885 2.25214 2.8777 2.92054 2.28329 3.73427C1.68889 4.548 1.28668 5.4859 1.10693 6.47745C0.927168 7.469 0.97453 8.48839 1.24545 9.459C1.51638 10.4296 2.00381 11.3262 2.67111 12.0813"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5046 11.8313L10.1712 8.49796L6.83789 11.8313"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AttachIcon;
